/**
 * The course's generated signature tile.
 *
 * One recognition mechanism per course: a hue shared by its subject and a
 * motif of its own, drawn as a stroke glyph on the hue's tint (ADR 0035). It
 * always renders, so a course never looks unfinished for lack of an image.
 * Decorative by contract: the code and title beside it carry the accessible
 * identity.
 */
import { CourseGlyph } from "@/components/workspace/CourseGlyph";
import { COURSE_HUE, COURSE_TINT, courseSignature } from "@/lib/course-signature";
import { cn } from "@/lib/utils";

export function CourseSignature({ code, className }: { code: string; className?: string }) {
  const { hue, motif } = courseSignature(code);
  return (
    <svg
      viewBox="0 0 64 64"
      aria-hidden="true"
      focusable="false"
      className={cn("size-14 shrink-0 sm:size-16", className)}
      style={{ color: COURSE_HUE[hue] }}
      data-course-signature={`${hue}:${motif}`}
    >
      <rect width="64" height="64" rx="12" style={{ fill: COURSE_TINT[hue] }} />
      <CourseGlyph motif={motif} x={13} y={13} width={38} height={38} />
    </svg>
  );
}
